import { Spin } from 'antd';
import React, { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../components/Layout';
import Menu from '../../components/Layout/Menu';

const ArticlesContent = lazy(() => import('../../components/Pages/Articles'));

export default function Articles(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Articles page`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <ArticlesContent />
      </Suspense>
    </Layout>
  );
}
